export function billingReducer(state = {
    withdraw: null,
    history: null,
    balance: null,
    isPending: true,
    isPendingBalance: true,
  }, action){
    switch(action.type){
        
      case 'GET_WITHDRAW_FULFILLED':
        return Object.assign({}, state, {
            withdraw: action.payload.data.results.data,
            isPending: false,
        })
        case 'EDIT_BANK_DATA':
          const {balance} = state;
          balance[action.name] = action.value; 
          return Object.assign({}, state, {
            balance,
            isPending: false,
        })


        case "GET_HISTORY_FULFILLED":
            return Object.assign({}, state, {
              history: action.payload.data.results.data,
              isPending: false,
            })
      
        case "GET_BALANCE_FULFILLED":
            return Object.assign({}, state, {
              balance: action.payload.data.results,
              isPendingBalance: false,
            })
          
        case "GET_BALANCE_PENDING":
            return Object.assign({}, state, {
              balance: null,
              isPendingBalance: true,
            })


        case 'GET_WITHDRAW_PENDING':
        return Object.assign({}, state, {
            withdraw: null,
            isPending: true,
        })

        case "GET_HISTORY_FULFILLED":
            return Object.assign({}, state, {
              history:  null,
              isPending: true,
            })
      default:
        return state
    }
  }


  export function billingDetailReducer(state = {
    data: null,
    links: null,
    isPending: true,
  }, action){
    switch(action.type){
      case 'GET_WITHDRAW_DETAIL_FULFILLED':
        return Object.assign({}, state, {
          data:  action.payload.data.results.meta.current_page === 1 ?
                  action.payload.data.results.data : 
                  state.data.concat(action.payload.data.results.data),
          links: action.payload.data.results.links,
          isPending: false,
        })


        case "GET_HISTORY_DETAIL_FULFILLED":
            return Object.assign({}, state, {
              data:  action.payload.data.results.meta.current_page === 1 ?
                      action.payload.data.results.data : 
                      state.data.concat(action.payload.data.results.data),
              links: action.payload.data.results.links,
              isPending: false,
            })

        case "RESET_BILLING_DETAIL":
            return Object.assign({}, state, {
              data:  null,
              isPending: true,
            })
      default:
        return state
    }
  }